// src/js/pages/PresupuestosParticipativosPage/PresupuestosParticipativosPage.jsx

import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { forwardTo } from '../../helpers';

import './PresupuestosParticipativosPage.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHandHoldingUsd,
    faGlobe,
    faUserEdit,
    faVoteYea,
    faSpinner,
    faCheckCircle,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

class PresupuestosParticipativosPage extends React.Component {
    constructor(props) {
        super(props);
        this.openTemplateUrl = this.openTemplateUrl.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    getUserToken() {
        const { user } = this.props;
        return (user && (user.shortToken || user.token)) || '';
    }

    getUserIdiomaID() {
        const lngFull  = (this.props.i18n && this.props.i18n.language) || 'es';
        const lng = lngFull.split(/[-_]/)[0];
        return (lng === 'ca') ? 'cat' : lng; // portal quiere 'cat'
    }

    

    applyPlaceholders(urlTemplate) {
        const token = encodeURIComponent(this.getUserToken());
        const idioma = encodeURIComponent(this.getUserIdiomaID());
        return (urlTemplate || '')
            .replaceAll('<@token@>', token)
            .replaceAll('<@idiomaID@>', idioma);
    }

    // ✅ Formato que has verificado que funciona en portal.gecorcloud.com:
    // login.aspx?ReturnUrl=ENC(/frmP1.aspx?Constante=..&token=..&idioma=..)&Constante=..&token=..&idioma=..
    toPortalLoginUrl(finalUrl) {
        const u = new URL(finalUrl);
        const inner = u.pathname + u.search;

        // fuerza %xx en minúsculas como tu ejemplo
        const returnUrlEnc = encodeURIComponent(inner).replace(/%[0-9A-F]{2}/g, (m) =>
            m.toLowerCase()
        );

        const outerQuery = u.search ? `&${u.search.substring(1)}` : '';
        return `https://portal.gecorcloud.com/login.aspx?ReturnUrl=${returnUrlEnc}${outerQuery}`;
    }

    openTemplateUrl(urlTemplate) {
        const finalUrl = this.applyPlaceholders(urlTemplate);

        try {
            const u = new URL(finalUrl);
            const isPortal = u.hostname === 'portal.gecorcloud.com';
            const isLogin = u.pathname.toLowerCase() === '/login.aspx';

            const urlToOpen = isPortal && !isLogin ? this.toPortalLoginUrl(finalUrl) : finalUrl;
            window.open(urlToOpen, '_blank', 'noopener,noreferrer');
        } catch {
            window.open(finalUrl, '_blank', 'noopener,noreferrer');
        }
    }

    render() {
        const { t, entity } = this.props;

        return (
            <div className="pp-wrapper">
                <Row className="justify-content-center w-100">
                    <Col xs={12} md={10} lg={8} xl={7}>
                        <Card className="pp-card p-3">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <h4 className="m-0">
                                    <FontAwesomeIcon icon={faHandHoldingUsd} /> {t('nav.nav14')}
                                </h4>

                                <Button variant="link" className="pp-back" onClick={() => forwardTo('/')}>
                                    ← {t('common.back', 'Volver')}
                                </Button>
                            </div>

                            <div className="text-muted mb-3">
                                {t('nav.nav14-desc', 'Accede a las secciones de presupuestos participativos')}
                            </div>

                            <ListGroup className="pp-list">
                                <ListGroup.Item
                                    action
                                    className="pp-item"
                                    onClick={() =>
                                        this.openTemplateUrl(
                                            'https://portal.gecorcloud.com/frmP1.aspx?Constante=37023&token=<@token@>&idioma=<@idiomaID@>'
                                        )
                                    }
                                >
                                    <span className="pp-left">
                                        <FontAwesomeIcon icon={faGlobe} className="pp-ico" /> {t('nav.nav14-1')}
                                    </span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </ListGroup.Item>

                                <ListGroup.Item
                                    action
                                    className="pp-item"
                                    onClick={() =>
                                        this.openTemplateUrl(
                                            'https://portal.gecorcloud.com/frmP1.aspx?Constante=37027&token=<@token@>&idioma=<@idiomaID@>'
                                        )
                                    }
                                >
                                    <span className="pp-left">
                                        <FontAwesomeIcon icon={faUserEdit} className="pp-ico" /> {t('nav.nav14-2')}
                                    </span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </ListGroup.Item>

                                <ListGroup.Item
                                    action
                                    className="pp-item"
                                    onClick={() =>
                                        this.openTemplateUrl(
                                            'https://portal.gecorcloud.com/frmP1.aspx?Constante=37028&token=<@token@>&idioma=<@idiomaID@>'
                                        )
                                    }
                                >
                                    <span className="pp-left">
                                        <FontAwesomeIcon icon={faVoteYea} className="pp-ico" /> {t('nav.nav14-3')}
                                    </span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </ListGroup.Item>

                                <ListGroup.Item
                                    action
                                    className="pp-item"
                                    onClick={() =>
                                        this.openTemplateUrl(
                                            'https://portal.gecorcloud.com/frmP1.aspx?Constante=37030&token=<@token@>&idioma=<@idiomaID@>'
                                        )
                                    }
                                >
                                    <span className="pp-left">
                                        <FontAwesomeIcon icon={faSpinner} className="pp-ico" /> {t('nav.nav14-4')}
                                    </span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </ListGroup.Item>

                                <ListGroup.Item
                                    action
                                    className="pp-item"
                                    onClick={() =>
                                        this.openTemplateUrl(
                                            'https://portal.gecorcloud.com/frmP1.aspx?Constante=37031&token=<@token@>&idioma=<@idiomaID@>'
                                        )
                                    }
                                >
                                    <span className="pp-left">
                                        <FontAwesomeIcon icon={faCheckCircle} className="pp-ico" /> {t('nav.nav14-5')}
                                    </span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { entities, users } = state;
    const { user } = users;
    const { entity } = entities;

    if (!user) {
        const path = window.location.pathname || '';
        if (!path.startsWith('/login')) {
            const returnUrl = window.location.pathname + window.location.search; // NO hash
            forwardTo(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
        }
    }
    return { user, entity };
};

const tPage = withTranslation()(PresupuestosParticipativosPage);
const connectedPage = connect(mapStateToProps)(tPage);
export { connectedPage as PresupuestosParticipativosPage };
